import { createEvent as l, createStore as d, createEffect as $, scopeBind as b, attach as E, sample as c, combine as z } from "effector";
function g(n, t) {
  try {
    const e = n();
    return e === void 0 ? t : e;
  } catch {
    return t;
  }
}
function v({
  add: n,
  remove: t,
  readPayload: e
}, a) {
  const i = l(), o = d(null, {
    serialize: "ignore"
  }), r = $(() => {
    const u = b(i, { safe: !0 });
    let f = u;
    return e && (f = () => u(e())), n(f), f;
  }), s = E({
    source: o,
    effect(u) {
      u && t(u);
    }
  });
  return c({ clock: a.setup, target: r }), c({
    clock: r.doneData,
    filter: Boolean,
    target: o
  }), a.teardown && c({ clock: a.teardown, target: s }), c({ clock: s.done, target: o.reinit }), i;
}
const h = (n) => {
  const t = d(
    g(() => screen.orientation.type, null),
    {
      serialize: "ignore"
    }
  ), e = d(
    g(() => screen.orientation.angle, null),
    { serialize: "ignore" }
  ), a = t.map((r) => r === "landscape-primary" || r === "landscape-secondary"), i = t.map((r) => r === "portrait-primary" || r === "portrait-secondary"), o = v(
    {
      add: (r) => screen.orientation.addEventListener("change", r),
      remove: (r) => screen.orientation.removeEventListener("change", r),
      readPayload: () => screen.orientation
    },
    n
  );
  return c({
    clock: o,
    fn: () => screen.orientation.type,
    target: t
  }), c({
    clock: o,
    fn: () => screen.orientation.angle,
    target: e
  }), { $type: t, $angle: e, $portrait: i, $landscape: a };
};
h["@@trigger"] = () => {
  const n = l(), t = l(), { $type: e } = h({ setup: n, teardown: t }), a = c({
    clock: e.updates,
    fn: () => {
    }
  });
  return { setup: n, teardown: t, fired: a };
};
const w = (n) => {
  const t = v(
    {
      add: (s) => document.addEventListener("visibilitychange", s),
      remove: (s) => document.removeEventListener("visibilitychange", s),
      readPayload: () => document.visibilityState
    },
    n
  ), e = d(
    g(() => document.visibilityState, "visible"),
    { serialize: "ignore" }
  ).on(t, (s, u) => u), a = e.map((s) => s === "visible"), i = e.map((s) => s === "hidden"), o = c({
    clock: a.updates,
    filter: Boolean,
    fn: () => {
    }
  }), r = c({
    clock: i.updates,
    filter: Boolean,
    fn: () => {
    }
  });
  return { visible: o, hidden: r, $visible: a, $hidden: i };
};
w["@@trigger"] = () => {
  const n = l(), t = l(), { visible: e } = w({ setup: n, teardown: t });
  return { setup: n, teardown: t, fired: e };
};
const k = (n) => {
  const t = v(
    {
      add: (o) => window.addEventListener("online", o),
      remove: (o) => window.removeEventListener("online", o)
    },
    n
  ), e = v(
    {
      add: (o) => window.addEventListener("offline", o),
      remove: (o) => window.removeEventListener("offline", o)
    },
    n
  ), a = d(
    g(() => navigator.onLine, !0),
    { serialize: "ignore" }
  ).on(t, () => !0).on(e, () => !1), i = a.map((o) => !o);
  return { online: t, offline: e, $offline: i, $online: a };
};
k["@@trigger"] = () => {
  const n = l(), t = l(), { online: e } = k({ setup: n, teardown: t });
  return { setup: n, teardown: t, fired: e };
};
function y(n, t) {
  if (typeof n == "string") {
    if (t)
      return p(n, t);
    {
      const e = (a) => p(n, a);
      return e["@@trigger"] = () => {
        const a = l(), i = l(), { matched: o } = p(n, { setup: a, teardown: i });
        return { setup: a, teardown: i, fired: o };
      }, e;
    }
  } else if (t) {
    const e = {};
    for (const [a, i] of Object.entries(n))
      e[a] = y(i, t);
    return e;
  } else {
    const e = {};
    for (const [a, i] of Object.entries(n))
      e[a] = (o) => y(i, o);
    return e;
  }
}
function p(n, t) {
  const e = g(() => window.matchMedia(n), null), a = v(
    {
      add: (r) => e == null ? void 0 : e.addEventListener("change", r),
      remove: (r) => e == null ? void 0 : e.removeEventListener("change", r)
    },
    t
  ), i = d((e == null ? void 0 : e.matches) ?? !1, {
    serialize: "ignore"
  }).on(a, (r, s) => s.matches), o = l();
  return c({
    clock: [i.updates, t.setup],
    filter: i,
    fn: () => {
    },
    target: o
  }), { $matches: i, matched: o };
}
const L = d(null, {
  serialize: "ignore"
}), S = L.map((n) => n ? n.split(",").map((t) => {
  var e;
  return (e = t.split(";")[0]) == null ? void 0 : e.trim();
}).filter((t) => t && t !== "*") : []), m = (n) => {
  const t = d(
    g(() => navigator.languages, []),
    { serialize: "ignore" }
  ), e = v(
    {
      add: (r) => window.addEventListener("languagechange", r),
      remove: (r) => window.removeEventListener("languagechange", r),
      readPayload: () => navigator.languages
    },
    n
  );
  c({ clock: e, target: t });
  const a = z(
    { fromHeader: S, fromNavigator: t },
    ({ fromHeader: r, fromNavigator: s }) => r.length > 0 ? r : s
  ), i = a.map(
    (r) => r[0] ?? null
  ), o = c({
    clock: e,
    fn() {
    }
  });
  return { $languages: a, $language: i, languageChanged: o };
};
m["@@trigger"] = () => {
  const n = l(), t = l(), { languageChanged: e } = m({ setup: n, teardown: t });
  return { setup: n, teardown: t, fired: e };
};
m.$acceptLanguageHeader = L;
export {
  y as trackMediaQuery,
  k as trackNetworkStatus,
  w as trackPageVisibility,
  m as trackPreferredLanguages,
  h as trackScreenOrientation
};
